import React, { useState, useEffect } from "react";
import { Button } from "@progress/kendo-react-buttons";
import { Dialog } from "@progress/kendo-react-dialogs";
import { GridToolbar } from "@progress/kendo-react-grid";
import { Input } from "@progress/kendo-react-inputs";
import FilterBuilder from "../../FilterBuilder"
import moment from "moment";
import { Utils } from "../../../helpers";
const blackListedOperators = {
  date: [],
  numeric: [],
  number: [],
  text: [],
  select: [],
  boolean: [],
};
const initialFilter = { logic: "and", filters: [] };

const FilterViewer = (props) => {
  const [filterConfig, setFilterConfig] = useState([]);
  const [showFilterBuilder, setShowFilterBuilder] = useState(false);
  const [appliedFilters, setAppliedFilters] = useState(props.appliedFilters || initialFilter);
  const [workingFilters, setWorkingFilters] = useState(props.appliedFilters || initialFilter);
  const [searchFilters, setSearchFilters] = useState({});
  const [searchValue, setSearchValue] = useState("");
  const [disableApplyBtn, setDisableApplyBtn] = useState(false);

  useEffect(() => {
    if (props.columnConfig?.length > 0) {
      let filterConfig = [];
      props.columnConfig
        ?.filter((col) => col.filterable === true && !!col.hidden === false)
        ?.map((col) => {
          let obj = {
            name: col.field,
            label: col.title,
            type: col.filter || col.type || "text",
          };
          filterConfig.push(obj);
        });
      setFilterConfig(filterConfig);
    }
  }, [props.columnConfig]);



  const handleSearchFilters = (event) => {
    let searchedValue = event.target.value;
    setSearchValue(searchedValue);
    if (searchedValue) {
      const searchFilters = filterConfig
        .filter(col =>
          col.type !== "boolean" &&
          (
            (col.type === "number" && !isNaN(searchedValue)) ||
            (col.type === "numeric" && !isNaN(searchedValue)) ||
            (col.type === "date" && Utils.isValidDateFormat(searchedValue)) ||
            (col.type === "text" && searchedValue?.trim() !== "")
          )
        )
        .map(col => ({
          field: col.name,
          operator: (col.type === "date" || col.type === "number" || col.type === "numeric") ? "eq" : "contains",
          value: col.type === "date" ? (moment(searchedValue).isValid() ? moment(searchedValue).format("YYYY-MM-DD") : "") : searchedValue
        }));

      const searchFilterGroup = {
        logic: "or",
        filters: searchFilters,
      };
      setSearchFilters(searchFilterGroup);
      applyFilter(searchFilterGroup);
    } else {
      setSearchFilters({});
      applyFilter();
    }
  };

  const applyFilter = (searchFilters = undefined, appliedFilters = props.appliedFilters, isSaveConfig = false) => {
    // Combine all filters
    const allFilters = [props.defaultFilters?.filter, appliedFilters, searchFilters]
      .filter(filter => filter?.filters?.length > 0);

    const finalFilters = {
      ...(allFilters.length > 0 && {
        filter: allFilters.length === 1
          ? allFilters[0]
          : { logic: "and", filters: allFilters }
      })
    };

    props.saveAndApplyFilter({ finalFilters, appliedFilters });
    isSaveConfig && props.saveColumnConfiguration(props.columnConfig, props.defaultFilters, appliedFilters);
    setShowFilterBuilder(false);
  }

  return (
    <div className="k-grid-filter-container">
      <GridToolbar className="grid-filter-toolbar">
        <div className="k-grid-custom-search">
          <i className="fas fa-magnifying-glass grid-search-icon" />
          <Input
            className="grid-serach-input"
            placeholder="Search..."
            value={searchValue}
            onChange={handleSearchFilters}
          />
        </div>
        <Button
          onClick={() => {
            setWorkingFilters(appliedFilters);
            setShowFilterBuilder(true);
          }}
          fillMode={"outline"}
          title={`Apply filters`}
          className="grid-filter-button"
        >
          <i class="fa-regular fa-filter grid-filter-icon"></i>
          Filter
          {appliedFilters.filters.length > 0 && <span class="grid-filter-count">{appliedFilters.filters.length}</span>}
        </Button>
        {appliedFilters.filters.length > 0 && (
          <Button
            fillMode={"outline"}
            title={`Clear all filters`}
            className="k-grid-btn-outline reset-btn"
            onClick={() => {
              setAppliedFilters(initialFilter);
              setSearchFilters({});
              setSearchValue("");
              applyFilter({}, initialFilter, true);
            }}
          >
            <i class="fa-solid fa-xmark"></i>
          </Button>
        )}
      </GridToolbar>

      {showFilterBuilder && (
        <Dialog className="filter-builder-modal" appendTo={document.querySelector(`[data-id="${props.appName}_Window"] .page-active`)?.getElementsByClassName("k-grid-filter-container")[0]}>
          <div className="filter-builder-container">
            <i className="fa-solid fa-xmark close-icon" onClick={() => setShowFilterBuilder(false)}></i>
            <FilterBuilder
              appName={props.appName}
              filterConfig={filterConfig}
              selectedFilters={workingFilters}
              blackListedOperators={blackListedOperators}
              disableApplyBtn={(value) => setDisableApplyBtn(value)}
              onFilterUpdate={(filter) => {
                setWorkingFilters(filter);
              }}
            />
            <div className="filter-builder-btns">
              <Button
                fillMode={"outline"}
                title={`Apply`}
                className="k-grid-btn-outline apply-btn"
                onClick={() => {
                  setAppliedFilters(workingFilters);
                  applyFilter(searchFilters, workingFilters, true);
                }}
                disabled={disableApplyBtn}
              >
                Apply
              </Button>
            </div>
          </div>
        </Dialog>
      )}
    </div>
  );
};

export default FilterViewer;
